import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'

export const CtaWrap = styled.div`
  background: ${COLORS.TAN};
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
`

export const CtaContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin: auto;
  max-width: 1280px;
  text-align: center;
  > div {
    flex: 1;
    width: 100%;
    text-align: center;
    img {
      max-width: 500px;
      width: 100%;
    }
  }
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
    flex-direction: row;
    justify-content:center;
  `}
`
